import * as React from 'react';
import { Loader } from 'semantic-ui-react';

import './styles.css';

export class PendingStatusIcon extends React.Component {
  render() {
    return <Loader inline={true} active={true}/>;
  }
}


// WEBPACK FOOTER //
// ./src/components/operation-grid/cells/status/pending.tsx